import { render, staticRenderFns } from "./TextNoPicture.vue?vue&type=template&id=2845e974&"
import script from "./TextNoPicture.vue?vue&type=script&lang=js&"
export * from "./TextNoPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports